<template>
  <form :data-id="_uid" @submit.prevent="handleSubmit" class="panel-search">
    <input type="text" v-model="model" :placeholder="placeholder" />
    <button type="submit">
      <SvgIcon name="chat-search" />
    </button>
  </form>
</template>

<script>
import { withUi } from '@/components/ui'

export default {
  mixins: [withUi],
  // data() {
  //   return {
  //     search: null,
  //   }
  // },
  props: {
    value: String,
    input: Function,
    placeholder: String,
  },
  computed: {
    model: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
  },
  methods: {
    handleSubmit(e) {
      console.log(e)
    },
  },
}
</script>

<style lang="scss" scoped>
.panel-search {
  position: relative;

  input {
    -webkit-appearance: none;
    box-shadow: none;
    border: 1px solid rgba(180, 187, 198, 0.19);
    border-radius: 5px;
    display: block;
    font-size: 14px;
    line-height: 17px;
    padding: 16px 16px;
    // conflict height 30px resolve
    height: auto;
    transition: border 0.25s ease;
    &::placeholder {
      color: $dark;
    }
    &:focus {
      border-color: $text;
    }
  }
  button {
    -webkit-appearance: none;
    position: absolute;
    right: 0;
    top: 0;
    background: transparent;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    font-size: 0;
    border: 0;
    padding: 17px 16px;
    // conflict height 30px resolve
    height: auto;
    color: $lightGray;

    &:hover {
      border: 0;
      opacity: 1;
      color: $primary;
    }
    .svg-icon {
      font-size: 14px;
      // conflict global 10px resolve
      margin-right: 0;
    }
  }
}
</style>
